import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FeatureNames,
  IsStringValueProperty,
  FeaturePropertyKey,
  Feature,
  StatusValueDefaultFeature,
} from '@vi-iot/client';

import { BufferTankOperatingModeType, InstallationFeaturesStore } from '@store';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-buffer-tank',
  templateUrl: './buffer-tank.component.html',
  styleUrls: ['./buffer-tank.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BufferTankComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly bufferTankOperatingModeType = BufferTankOperatingModeType;
  readonly availableOverlays = FeaturesDetailsOverlayTypeEnum;

  @Input() deviceId: string;

  bufferTankOperatingMode$: Observable<Feature<IsStringValueProperty, never>>;
  bufferTankTemperatureMain$: Observable<Feature<StatusValueDefaultFeature, never>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.bufferTankOperatingMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.bufferCylinderOperatingModes,
      this.deviceId
    );
    this.bufferTankTemperatureMain$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.bufferTankTemperatureMain,
      this.deviceId
    );
  }
}
